import { useQuery } from "@tanstack/react-query";
import { downloadExpiredPoints, downloadUpcomingPointExpiry } from "../../service/query/auth";

export const useDownloadExpiryReport = ({ payload }) => {
  const isUpcoming = payload?.pointType === "1";

  const expiryReport = useQuery({
    queryKey: ["point_expiry_report", payload],
    queryFn: () =>
      isUpcoming
        ? downloadUpcomingPointExpiry({ ...payload })
        : downloadExpiredPoints({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  });

  return { data: expiryReport?.data?.data, ...expiryReport };
};